<div class="form-group">
    <label [translate]="label"></label>
    <div class="chip-container border p-2 rounded">
        <span *ngFor="let chip of chips; let i = index" class="badge bg-primary me-2">
            {{ chip }}
            <button type="button" class="btn-close btn-close-white ms-1" (click)="removeChip(i)"></button>
        </span>
        <input type="text" [(ngModel)]="inputValue" class="border-0" (keyup)="addChip($event)"
            [placeholder]="'shared.chipInput' | translate">
    </div>
</div>
